// src/Components/SmallNavBar/SmallNavBar.js
import { useCallback, useEffect, useRef, useState } from 'react';
import '../../Home.css'; // Para agregar estilos opcionales
import useFetchMenu, { FEATURED_CATEGORY_ID } from '../../Hooks/UseFetchMenu';
import { Link, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

const SmallNavBar = () => {
  const { menuItems, loading } = useFetchMenu(API_BASE_URL);
  const { id } = useParams();
  // Los ids de categoria de SumUp son UUIDs (string), no numeros: no usar parseInt.
  const activeCategoryId = id ?? null;
  const hiddenCategoryIds = [FEATURED_CATEGORY_ID]; //IDS DE LAS OPCIONES DE CATEGORIA A OCULTAR (incluye destacados)

  const barRef = useRef(null);
  const activeRef = useRef(null);
  const [edges, setEdges] = useState({ atStart: true, atEnd: false });

  // Que degradado mostrar: solo del lado donde quedan categorias por ver.
  const updateEdges = useCallback(() => {
    const bar = barRef.current;
    if (!bar) return;
    setEdges({
      atStart: bar.scrollLeft <= 4,
      atEnd: bar.scrollLeft + bar.clientWidth >= bar.scrollWidth - 4,
    });
  }, []);

  // Al entrar en una categoria, centrar su boton en la barra (antes la
  // activa podia quedar fuera de pantalla, ej. "Cocktails").
  useEffect(() => {
    const bar = barRef.current;
    const active = activeRef.current;
    if (bar && active) {
      bar.scrollLeft = active.offsetLeft - (bar.clientWidth - active.offsetWidth) / 2;
    }
    updateEdges();
  }, [loading, activeCategoryId, updateEdges]);

  if (loading) {
    return <div></div>; // Mostrar indicador de carga
  }

  const wrapClass = [
    'small-category-wrap',
    edges.atStart ? 'at-start' : '',
    edges.atEnd ? 'at-end' : '',
  ].join(' ').trim();

  return (
    <div className={wrapClass}>
      <nav className="small-category-bar" ref={barRef} onScroll={updateEdges} aria-label="Categorías del menú">
        {menuItems
          .filter(category => !hiddenCategoryIds.includes(category.id))
          .map((category) => {
            const isActive = activeCategoryId !== null && String(activeCategoryId) === String(category.id);
            return (
              <Link
                key={category.id}
                ref={isActive ? activeRef : undefined}
                to={`/Category/${category.id}`}
                className={`small-category-button ${isActive ? 'active' : ''}`}
                aria-current={isActive ? 'page' : undefined}
              >
                {category.name}
              </Link>
            );
          })}
      </nav>
    </div>
  );
};

export default SmallNavBar;
